import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText } from "../../generateEmailParagraph"
import { registrationEmailUtmParameters } from "../../send/sendRegisterEmail"

export const generateGoogleMeetLinkAndProperties = (onlineMeetingUrl: string): string =>
  typeof onlineMeetingUrl === "undefined" || onlineMeetingUrl.length === 0
    ? ""
    : `        
        ${generateEmailText(`<strong>Jak se připojit do lekce kurzu?</strong>`)}
        ${generateEmailParagraph(
          `Připojení k lekci je snadné. Stačí kliknout na <a href="${onlineMeetingUrl}" title="Připojit se" target="_blank">tento odkaz</a> a postupovat podle pokynů. Po úspěšném ověření platby budete moci pokračovat na stránku Google Meet. Zadáte své jméno a připojíte se. Vše proběhne přímo ve vašem prohlížeči. <a href="https://vzdelanibudoucnosti.cz/blog/krouzky-pro-deti/google-meet-pruvodce-pro-rodice-a-deti${registrationEmailUtmParameters}" title="Připojit na náš blog" target="_blank">Přečtěte si náš průvodce připojením na našem blogu.</a>`
        )}
        ${generateEmailCallToActionButton(`Připojit se`, "Připojit se", `${onlineMeetingUrl}`)}
    `
